import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
} from 'react-icons/fa';
import logo from '../assets/logo.png'
import './Header.css'

const Header = () => {
  return (
    <div className="header-root">
      <div className='header-container'>
        <div className="header-socials">
          <a href="https://www.facebook.com/profile.php?id=61577893326904" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://www.instagram.com/drivein_car_spa/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.youtube.com/@DriveInCarSpa" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
        </div>
        <div className="header-logo">
          <img
            src={logo}
            alt="Drive-In Car Spa"
          />
        </div>
        <div className="header-callinfo">
          <div
            className="header-call-circle"
          >
            <FaPhoneAlt />
          </div>
          <div>
            <div className="header-call-help">Need help?</div>
            <div className="header-call-number"><a href="tel:+91-8951509309">+91-8951509309</a></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
